export default {
  INIT: (state) => {
    state.trendingTickers = { data: [], loading: false, error: null };
    state.trendingGainersTickers = { data: null, loading: false, error: null };
    state.trendingLosersTickers = { data: null, loading: false, error: null };
  },

  SET_TRENDING_TICKERS: (state, payload) => {
    state.trendingTickers.data = payload;
  },

  SET_TRENDING_TICKERS_LOADING: (state, isLoading) => {
    state.trendingTickers.loading = isLoading;
  },

  SET_TRENDING_TICKERS_ERROR: (state, error) => {
    state.trendingTickers.error = error;
  },

  SET_TRENDING_GAINERS_TICKERS: (state, payload) => {
    state.trendingGainersTickers.data = payload;
  },

  SET_TRENDING_GAINERS_TICKERS_LOADING: (state, isLoading) => {
    state.trendingGainersTickers.loading = isLoading;
  },

  SET_TRENDING_GAINERS_TICKERS_ERROR: (state, error) => {
    state.trendingGainersTickers.error = error;
  },

  SET_TRENDING_LOSERS_TICKERS: (state, payload) => {
    state.trendingLosersTickers.data = payload;
  },

  SET_TRENDING_LOSERS_TICKERS_LOADING: (state, isLoading) => {
    state.trendingLosersTickers.loading = isLoading;
  },

  SET_TRENDING_LOSERS_TICKERS_ERROR: (state, error) => {
    state.trendingLosersTickers.error = error;
  },
};
